import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { AccountApplicationsPage } from 'features/accountApplications'
import { subscriptionsQueryOptions } from 'hooks/api/subscriptions'

export const Route = createFileRoute('/_authenticated/_layout/settings/workspaces')({
  component: AccountApplicationsPage,
  loader: ({ context: { queryClient, buildRequest } }) => {
    queryClient.prefetchQuery(subscriptionsQueryOptions(buildRequest, ['usageQuota', 'projectedUsage', 'discounts']))
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Workspaces'),
      },
    ],
  }),
})
